import { render, staticRenderFns } from "./CallMobileResultPhoneCall.vue?vue&type=template&id=adfde062&scoped=true"
import script from "./CallMobileResultPhoneCall.vue?vue&type=script&lang=js"
export * from "./CallMobileResultPhoneCall.vue?vue&type=script&lang=js"
import style0 from "./CallMobileResultPhoneCall.vue?vue&type=style&index=0&id=adfde062&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfde062",
  null
  
)

export default component.exports